import React from 'react';
import { motion } from 'framer-motion';
import { useFetch } from '../lib/hooks';

const ORBIT = [0, 60, 120, 180, 240, 300];

export function LogoShowcase() {
  const { data } = useFetch('/markets/top?limit=10');
  const coins = (data?.coins || []).slice(0, 6);
  return (
    <motion.div data-testid="veyjex-hero-logo-container" className="relative grid place-items-center h-[420px] sm:h-[480px] group"
      initial={{ opacity: 0, scale: 0.94 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}>
      <div className="absolute w-[420px] h-[420px] rounded-full bg-gradient-to-r from-vj-neon/15 via-vj-gold/10 to-transparent blur-[100px]" />
      <div className="absolute w-[340px] h-[340px] sm:w-[400px] sm:h-[400px] rounded-full border border-vj-neon/20" />
      <div className="absolute w-[260px] h-[260px] sm:w-[300px] sm:h-[300px] rounded-full border border-dashed border-vj-gold/25 vj-spin-slow" />
      <div className="absolute inset-0 grid place-items-center vj-spin-reverse pointer-events-none">
        <div className="relative w-[340px] h-[340px] sm:w-[400px] sm:h-[400px]">
          {coins.map((c, i) => (
            <img key={c.id} src={c.image} alt={c.symbol} className="absolute w-7 h-7 rounded-full ring-2 ring-vj-obsidian"
              style={{ top: '50%', left: '50%', margin: -14, transform: `rotate(${ORBIT[i]}deg) translateX(var(--orbit-r)) rotate(-${ORBIT[i]}deg)` }} />
          ))}
        </div>
      </div>
      <div className="relative flex flex-col items-center">
        <motion.img src="/veyjex-emblem.webp" alt="VEYJEX emblem" data-testid="veyjex-hero-emblem"
          className="w-52 sm:w-64 mix-blend-screen vj-emblem-mask drop-shadow-[0_0_30px_rgba(57,255,20,0.35)] transition-transform duration-500 group-hover:scale-105"
          animate={{ y: [0, -8, 0] }} transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }} />
        <img src="/veyjex-wordmark.webp" alt="VEYJEX Global Trading Exchange" data-testid="veyjex-hero-wordmark" className="w-64 sm:w-80 -mt-1 mix-blend-screen vj-wordmark-mask" />
        <div data-testid="veyjex-si-bot-status-badge" className="mt-4 flex items-center gap-2 px-3 py-1 rounded-full bg-vj-obsidian border border-vj-neon/40 font-mono text-[11px] text-vj-neon">
          <span className="w-1.5 h-1.5 rounded-full bg-vj-neon animate-pulse" /> S.I. ENGINE · LIVE MARKET LINK
        </div>
      </div>
    </motion.div>
  );
}
